import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { doc, updateDoc, increment } from "firebase/firestore";
import JSZip from "jszip";
import { saveAs } from "file-saver";

function GalleryGrid({ onPhotoClick, photos }) {
    const [activeFilter, setActiveFilter] = useState("Wszystkie");
    const [visibleCount, setVisibleCount] = useState(12);

    const filters = ["Wszystkie", "Ceremonia", "Przyjęcie", "Zadania", "Inne"];

    // Filtrowanie — reaguje automatycznie na zmiany photos
    const filteredPhotos = (activeFilter === "Wszystkie"
        ? photos || []
        : (photos || []).filter((p) => p.category === activeFilter));

    const handleDownload = async (url, fileName, photoId) => {
        try {
            showToast("⏳ Pobieranie...");
            const response = await fetch(url, { mode: "cors" });
            if (!response.ok) throw new Error("Błąd pobierania");
            const blob = await response.blob();
            const blobUrl = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = fileName || "wesele.jpg";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setTimeout(() => URL.revokeObjectURL(blobUrl), 5000);

            await updateDoc(doc(db, "photos", photoId), {
                downloads: increment(1)
            });

            showToast("✓ Pobrano!");
        } catch (error) {
            console.error("Błąd:", error);
            showToast("❌ Błąd — spróbuj ponownie");
        }
    };

    const downloadAll = async () => {
        if (!photos || photos.length === 0) {
            showToast("❌ Brak zdjęć do pobrania!");
            return;
        }

        showToast(`⏳ Pakowanie ${photos.length} plików...`);

        try {
            const zip = new JSZip();
            const folder = zip.folder("wesele-klaudia-bartlomiej");

            const promises = photos.map(async (photo, index) => {
                try {
                    const response = await fetch(photo.url, { mode: "cors" });
                    const blob = await response.blob();
                    const extension = photo.fileName?.split(".").pop() || (photo.type === "video" ? "mp4" : "jpg");
                    const prefix = photo.type === "video" ? "filmik" : "zdjecie";
                    const fileName = `${prefix}_${String(index + 1).padStart(3, "0")}.${extension}`;
                    folder.file(fileName, blob);
                } catch (err) {
                    console.error(`Błąd pobierania pliku ${index + 1}:`, err);
                }
            });

            await Promise.all(promises);
            showToast("⏳ Generowanie pliku ZIP...");

            const content = await zip.generateAsync(
                { type: "blob" },
                (metadata) => {
                    showToast(`⏳ Pakowanie... ${Math.round(metadata.percent)}%`);
                }
            );

            saveAs(content, "wesele-klaudia-bartlomiej.zip");

            await updateDoc(doc(db, "photos", photos[0].id), {
                downloads: increment(1)
            });

            showToast(`✓ Pobrano ${photos.length} plików!`);

        } catch (error) {
            console.error("Błąd:", error);
            showToast("❌ Błąd pakowania — spróbuj ponownie");
        }
    };

    const showToast = (msg) => {
        const existing = document.querySelector(".toast");
        if (existing) existing.remove();
        const toast = document.createElement("div");
        toast.className = "toast";
        toast.textContent = msg;
        document.body.appendChild(toast);
        setTimeout(() => toast.remove(), 3000);
    };

    return (
        <div className="gal-body">

            {/* POBIERZ WSZYSTKIE */}
            <div className="download-all-wrap">
                <button className="download-all-btn" onClick={downloadAll}>
                    ⬇ Pobierz wszystkie ({photos?.length || 0})
                </button>
                <span className="download-all-sub">
          Wszystkie zdjęcia i filmiki w jednym pliku ZIP
        </span>
            </div>

            {/* FILTRY */}
            <div className="filter-row">
                {filters.map((filter) => (
                    <button
                        key={filter}
                        className={`f-btn ${activeFilter === filter ? "active" : ""}`}
                        onClick={() => setActiveFilter(filter)}
                    >
                        {filter}
                    </button>
                ))}
            </div>

            {/* BRAK ZDJĘĆ */}
            {filteredPhotos.length === 0 && (
                <div className="gallery-empty">
                    <span className="empty-icon">📷</span>
                    <p>Brak zdjęć — bądź pierwszy!</p>
                    <p>Dodaj zdjęcie lub filmik powyżej 👆</p>
                </div>
            )}

            {/* GALERIA MASONRY */}
            {filteredPhotos.length > 0 && (
                <div className="masonry">
                    {filteredPhotos.slice(0, visibleCount).map((photo) => (
                        <div
                            key={photo.id}
                            className="m-item"
                            onClick={() => onPhotoClick && onPhotoClick(
                                photos.indexOf(photo)
                            )}
                        >
                            {photo.type === "video" && (
                                <div className="video-badge">▶ Filmik</div>
                            )}

                            {photo.type === "video" ? (
                                <div className="m-video-wrap">
                                    <video
                                        src={photo.url}
                                        className="m-img"
                                        muted
                                        playsInline
                                        preload="metadata"
                                    />
                                    <div className="m-video-play-btn">▶</div>
                                </div>
                            ) : (
                                <img
                                    src={photo.url}
                                    alt={photo.fileName}
                                    className="m-img"
                                    loading="lazy"
                                    decoding="async"
                                    onError={(e) => {
                                        e.target.style.display = "none";
                                        e.target.parentElement.style.background = "rgba(255,107,71,0.1)";
                                        e.target.parentElement.innerHTML += `
                      <div style="position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;color:rgba(255,255,255,0.4);font-size:0.7rem;text-align:center;padding:10px;">
                        <span style="font-size:1.5rem;margin-bottom:8px;">⏳</span>
                        Konwersja w toku...<br/>odśwież za chwilę
                      </div>
                    `;
                                    }}
                                />
                            )}

                            <div className="m-bottom">
                                <div className="m-author-always">— {photo.author}</div>
                                <button
                                    className="m-download"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleDownload(photo.url, photo.fileName, photo.id);
                                    }}
                                >
                                    ⬇
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {/* Przycisk Załaduj więcej */}
            {filteredPhotos && visibleCount < filteredPhotos.length && (
                <div className="load-more-wrap">
                    <button
                        className="load-more-btn"
                        onClick={() => setVisibleCount((v) => v + 12)}
                    >
                        ⬇ Załaduj więcej ({filteredPhotos.length - visibleCount} pozostałych)
                    </button>
                </div>
            )}

        </div>
    );
}

export default GalleryGrid;